export default requester => {
    return {
        /**
         * Send email
         *
         * @param {object} handle
         **/
         send (body, params = {}) {
            return requester.post('/admin/mailer/message', body, { params });
        },

        /**
         * One-click unsubscribe by code.
         *
         * @param {string} code
         * @return {object}
         */
        unsubscribe (code) {
            return requester.post(`/unsubscribe/${code}`);
        },
    };
}
